<template>
  <div class="generate-result-page">
    <!-- 导航栏：统一风格 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">拍摄教程</div>
    </div>
    <div class="page-body">
      <div class="bodayTitle">正确样式</div>
      <div class="bodayFirst">
        <img
          class="bodayFirstImg"
          src="@/assets/aiVideo/sampleGraph1.png"
          alt="#"
        />

        <div class="bodayFirstTitle">
          <div>请竖屏拍摄，并擦干净摄像头</div>
          <div>先保持嘴巴闭合再开始录制讲话，拍摄时不要遮挡嘴巴、不要侧脸</div>
          <div>保持上半身出境，注意拍摄背景，荣誉墙、咖啡厅等营高级感</div>
          <div>上传2K/4K视频后可制作同清晰高清视频</div>
        </div>
      </div>
      <div class="bodayTitle">错误示例</div>
      <div class="bodySecond">
        <div class="bodySecondItem">
          <img
            src="@/assets/aiVideo/sampleGraph2.png"
            alt="#"
            class="bodySecondImg"
          />
          <div class="bodySecondTitle">挡住嘴巴</div>
        </div>
        <div class="bodySecondItem">
          <img
            src="@/assets/aiVideo/sampleGraph3.png"
            alt="#"
            class="bodySecondImg"
          />
          <div class="bodySecondTitle">人脸出框</div>
        </div>
        <div class="bodySecondItem">
          <img
            src="@/assets/aiVideo/sampleGraph4.png"
            alt="#"
            class="bodySecondImg"
          />
          <div class="bodySecondTitle">侧脸拍摄</div>
        </div>
        <div class="bodySecondItem">
          <img
            src="@/assets/aiVideo/sampleGraph5.png"
            alt="#"
            class="bodySecondImg"
          />
          <div class="bodySecondTitle">多人出镜</div>
        </div>
      </div>
      <div class="bodayTitle">视频教程</div>
      <!-- <div class=""></div> -->
      <div class="spjc" @click="showVideo = true">
        <img :src="spfm1" alt="#" class="bodyThird" />
        <img src="@/assets/aiVideo/sybf.png" alt="#" class="bodyTop-sybf" />
      </div>

      <div class="bottonBtn">
        <div class="bottonBtnOne btn" @click="uploadVideo">上传视频</div>
        <div class="bottonBtnTwo btn" @click="goPage()">自由拍摄</div>
      </div>
    </div>
    <FullScreenVideo
      :src="videoSrc"
      @error="handleVideoError"
      @goBack="goBack"
      v-if="showVideo"
    />
  </div>
</template>

<script>
import FullScreenVideo from "@/components/fullScreenVideo.vue";
import {
  deviceEnv
} from '@/utils/device.js';
export default {
  name: "recordingGuide",
  components: {
    FullScreenVideo,
  },
  data() {
    return {
      showVideo: false,
	  currentPlatform: '',
      selectedFile: null,
      selectedVideoUrl: null, // 用于预览
      spfm1:
        "https://newtouch-aihuman-dat.oss-cn-beijing.aliyuncs.com/newTouch/uploads/20260206/05a6e3c7ce464b99.jpg",
      videoSrc:
        "https://newtouch-aihuman-dat.oss-cn-beijing.aliyuncs.com/newTouch/uploads/20260206/a8b1c5f003614c73.mp4",
      isMiniProgram: false
    };
  },
  mounted() {
		this.isMiniProgram = deviceEnv.isWechatMiniProgram;
	  document.title = "拍摄教程";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
  },
  methods: {
    // 返回按钮逻辑
    onBack() {
      this.$router.go(-1);
      // this.$router.push({ path: this.$route.query.formPath });
    },
    //点击上传视频
    uploadVideo() {
      this.$router.push({
        path: "uploadVideo",
      });
    },

    // 重置选择
    resetSelection() {
      this.selectedFile = null;
      this.selectedVideoUrl = null;
      // 清空 input 值，确保下次能触发 change
    },
    // 关闭弹窗（点击阴影或主动调用）

    async goPage() {
      this.$router.push({
        path: "freeShooting",
      });
    },
    handleVideoError(error) {
      console.log(error);
    },
    goBack() {
      this.showVideo = false;
    },
  },
};
</script>

<style scoped>
/* 页面基础布局 */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

/* 导航栏（与原页面完全统一） */
.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}
.page-body {
  overflow-y: auto;
  padding: 5.333vw 4.2666vw 0 4.2666vw;
}
.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}
.bodayFirst {
  margin: 3.2vw 1.066vw 0 2.666vw;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-bottom: 5.333vw;
}
.bodayFirstImg {
  width: 38.4vw;
  height: 42.666vw;
}
.bodayFirstTitle {
  width: 45.066vw;
  line-height: 4.4vw;
  font-family: SourceHanSansSC-regular;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.9333vw;
  margin-top: 1.2vw;
}
.bodayFirstTitle > div:nth-child(2) {
  margin-top: 2.666vw;
}
.bodayFirstTitle > div:nth-child(3) {
  margin-top: 5.666vw;
}
.bodayFirstTitle > div:nth-child(4) {
  margin-top: 2.666vw;
}
.bodySecond {
  padding: 3.2vw 5.333vw 5.333vw 5.333vw;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.bodySecondItem {
  /* background-color: red;dis */
  display: flex;
  align-items: center;
  flex-direction: column;
}
.bodySecondImg {
  width: 18.666vw;
  height: 20vw;
}
.bodySecondTitle {
  margin-top: 3.466vw;
  color: #1f2226;
  font-weight: 400;
  font-size: 2.933vw;
  line-height: 4vw;
}
.spjc {
  position: relative;
}
.bodyThird {
  width: 86.133vw;
  height: 42.666vw;
  margin-left: 2.666vw;
  margin-top: 3.2vw;
}
.bodyTop-sybf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8vw;
  height: 8vw;
}
.bottonBtn {
  margin: 10.666vw 0 7.6vw 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  width: 29.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  line-height: 8vw;
  font-size: 3.2vw;
  text-align: center;
}
.bottonBtnOne {
  margin-right: 3.2vw;

  background-color: #ebebed;
  font-weight: 500;
  color: #666666;
  opacity: 0.8;
}
.bottonBtnTwo {
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
  color: #ffffff;
}
</style>
